import React, { lazy, Suspense } from "react";
import { Redirect } from "react-router-dom";

const Admin = lazy(() => import("../views/Admin"));
const Settings = lazy(() => import("../views/Admin/Settings"));
const Track = lazy(() =>
    import("../views/Admin/RealTimeTrack")
);

const RequestPerformance = lazy(() =>
    import("../views/Admin/Performance/RequestPerformance")
);

const SystemInformation = lazy(() =>
    import("../views/Admin/components/SystemInformation")
);

const GitLogs = lazy(() =>
    import("../views/Admin/components/SystemInformation/GitLogs")
);

const SettingsState = lazy(() =>
    import("../views/Admin/Settings/context/SettingsState")
);

const AdminRoutes = props => {
    const {
        match: { params: { verb, id, component } },
        CanI
    } = props;

    const adminRoot = "/app/admin";

    try {
        if (id === undefined && verb === undefined) {
            return (
                <Suspense fallback={<div>{component} loading...</div>}>
                    <Admin component={component} />
                </Suspense>
            );
        }

        switch (verb) {
            case "settings":
                return (
                    <SettingsState>
                        <Suspense fallback={<div>{component} loading...</div>}>
                            <Settings CanI={CanI} />
                        </Suspense>
                    </SettingsState>
                );
            case "track":
                return (
                    <Suspense fallback={<div>{component} loading...</div>}>
                        <Track CanI={CanI} />
                    </Suspense>
                );
            case "system-information":
                return (
                    <Suspense fallback={<div>{component} loading...</div>}>
                        <SystemInformation {...props} />
                    </Suspense>
                );
            case "git-logs":
                return (
                    <Suspense fallback={<div>{component} loading...</div>}>
                        <GitLogs {...props} />
                    </Suspense>
                );
            case "request-performance":
                return (
                    <Suspense fallback={<div>{component} loading...</div>}>
                        <RequestPerformance {...props} />
                    </Suspense>
                );
            default:
                return <Redirect to={adminRoot} />;
        }
    }
    catch (error) {
        console.debug({ [component]: error });
        return <h1>Error Occur - Page not found </h1>;
    }
};

export default AdminRoutes;